export const SET_SELECTED_RECEIVE_HR_NOTIFICATION = 'SET_SELECTED_HR_INTERNAL_NOTIFICATION';
export const SET_UNCOMPLETED_COUNT = 'SET_UNCOMPLETED_COUNT';
